import {useState} from 'react';
import {Logo, scrollToSection} from './navigation-common';

import {AnimatePresence, motion} from 'motion/react';

import styles from './navigation.module.scss';
import mobileStyles from './navigation-mobile.module.scss';

export function NavigationMobile() {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={`${mobileStyles.navigation} ${styles.navigation}`}>
            <div className={mobileStyles.navContent}>
                <Logo />
                <div onClick={() => setIsOpen(!isOpen)}>
                    {!isOpen ? (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                        >
                            <path
                                d="M4.25 17.634C4.0375 17.634 3.85942 17.5621 3.71575 17.4182C3.57192 17.2746 3.5 17.0964 3.5 16.8837C3.5 16.6712 3.57192 16.4932 3.71575 16.3495C3.85942 16.206 4.0375 16.1342 4.25 16.1342H19.75C19.9625 16.1342 20.1406 16.2061 20.2843 16.3497C20.4281 16.4936 20.5 16.6718 20.5 16.8845C20.5 17.097 20.4281 17.2751 20.2843 17.4187C20.1406 17.5622 19.9625 17.634 19.75 17.634H4.25ZM4.25 12.7495C4.0375 12.7495 3.85942 12.6776 3.71575 12.5337C3.57192 12.3899 3.5 12.2117 3.5 11.9992C3.5 11.7866 3.57192 11.6085 3.71575 11.465C3.85942 11.3213 4.0375 11.2495 4.25 11.2495H19.75C19.9625 11.2495 20.1406 11.3214 20.2843 11.4652C20.4281 11.6091 20.5 11.7872 20.5 11.9997C20.5 12.2124 20.4281 12.3905 20.2843 12.534C20.1406 12.6777 19.9625 12.7495 19.75 12.7495H4.25ZM4.25 7.86474C4.0375 7.86474 3.85942 7.79291 3.71575 7.64924C3.57192 7.50541 3.5 7.32716 3.5 7.11449C3.5 6.90199 3.57192 6.72391 3.71575 6.58024C3.85942 6.43674 4.0375 6.36499 4.25 6.36499H19.75C19.9625 6.36499 20.1406 6.43691 20.2843 6.58074C20.4281 6.72441 20.5 6.90257 20.5 7.11524C20.5 7.32774 20.4281 7.50582 20.2843 7.64949C20.1406 7.79299 19.9625 7.86474 19.75 7.86474H4.25Z"
                                fill="white"
                            />
                        </svg>
                    ) : (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                        >
                            <path
                                d="M11.9927 13.0479L6.91969 18.1212C6.78119 18.2595 6.6071 18.3303 6.39744 18.3337C6.18794 18.3368 6.01069 18.266 5.86569 18.1212C5.72085 17.9762 5.64844 17.8005 5.64844 17.5942C5.64844 17.3878 5.72085 17.2122 5.86569 17.0672L10.9389 11.9942L5.86569 6.92115C5.72735 6.78265 5.65652 6.60857 5.65319 6.3989C5.65002 6.1894 5.72085 6.01215 5.86569 5.86715C6.01069 5.72232 6.18635 5.6499 6.39269 5.6499C6.59902 5.6499 6.77469 5.72232 6.91969 5.86715L11.9927 10.9404L17.0657 5.86715C17.2042 5.72882 17.3783 5.65799 17.5879 5.65465C17.7974 5.65149 17.9747 5.72232 18.1197 5.86715C18.2645 6.01215 18.3369 6.18782 18.3369 6.39415C18.3369 6.60049 18.2645 6.77615 18.1197 6.92115L13.0464 11.9942L18.1197 17.0672C18.258 17.2057 18.3289 17.3797 18.3322 17.5894C18.3354 17.7989 18.2645 17.9762 18.1197 18.1212C17.9747 18.266 17.799 18.3384 17.5927 18.3384C17.3864 18.3384 17.2107 18.266 17.0657 18.1212L11.9927 13.0479Z"
                                fill="white"
                            />
                        </svg>
                    )}
                </div>
            </div>
            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        className={mobileStyles.menu}
                        initial={{opacity: 0, height: 0}}
                        animate={{opacity: 1, height: '100vh'}}
                        exit={{opacity: 0, height: 0}}
                        transition={{duration: 0.4}}
                    >
                        <motion.div
                            className={`${mobileStyles.menuItem} ${styles.menuItemActive}`}
                            initial={{opacity: 0}}
                            animate={{opacity: 1}}
                            exit={{opacity: 0}}
                            transition={{duration: 0.4}}
                        >
                            <span className={mobileStyles.menuText}>About</span>
                            <span className={mobileStyles.menuIndex}>01</span>
                        </motion.div>
                        <motion.div
                            className={mobileStyles.menuItem}
                            initial={{opacity: 0}}
                            animate={{opacity: 1}}
                            exit={{opacity: 0}}
                            transition={{duration: 0.4, delay: 0.1}}
                            onClick={() => {
                                setIsOpen(false);
                                scrollToSection('learning-tools');
                            }}
                        >
                            <span className={mobileStyles.menuText}>Learning Tools</span>
                            <span className={mobileStyles.menuIndex}>02</span>
                        </motion.div>
                        <motion.div
                            className={mobileStyles.menuItem}
                            initial={{opacity: 0}}
                            animate={{opacity: 1}}
                            exit={{opacity: 0}}
                            transition={{duration: 0.4, delay: 0.2}}
                            onClick={() => {
                                setIsOpen(false);
                                scrollToSection('studio-info');
                            }}
                        >
                            <span className={mobileStyles.menuText}>Studio Info</span>
                            <span className={mobileStyles.menuIndex}>03</span>
                        </motion.div>
                        <motion.div
                            className={mobileStyles.menuItem}
                            initial={{opacity: 0}}
                            animate={{opacity: 1}}
                            exit={{opacity: 0}}
                            transition={{duration: 0.4, delay: 0.3}}
                            onClick={() => {
                                setIsOpen(false);
                                scrollToSection('new-course');
                            }}
                        >
                            <span className={mobileStyles.menuText}>New Course</span>
                            <span className={mobileStyles.menuIndex}>04</span>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}
